/**
 * The facts the privacy policy, the terms and the connector page state about
 * who publishes Fint. One place, so the three pages cannot disagree - and so
 * the next change of address is one edit, not a search.
 *
 * ── THE EFFECTIVE DATE ──
 * The day the current wording went live. Change it in the same commit as any
 * change to what the policy or the terms PROMISE (not for a typo), and the
 * pages tell readers so; a material change also needs 30 days' notice to
 * existing users, which the policy itself commits to.
 */
export const PUBLISHER = {
  name: 'CyberFreezeDev LLP',
  address: ['No 51/2, Appadurai Pillai Street', 'Thundalam', 'Chennai, Tamil Nadu 600077', 'India'],
  gstin: '33AAUFC5152F1ZG',
  email: 'hello@cyberfreezedev.com',
  website: 'https://cyberfreezedev.com',
  grievanceOfficer: 'Saidharshan S',
  courts: 'Chennai',
} as const;

export const LEGAL_EFFECTIVE_DATE = '14 October 2026';

/** The MCP address for this deployment, exactly as a connector must be given it: no trailing slash. */
export function mcpUrl(origin: string = window.location.origin): string {
  return `${origin.replace(/\/+$/, '')}/v1/mcp`;
}
